/**
 * Structured logs for batch determination + replan diagnosis.
 * Filter the browser console with: WizardBatchQty
 *
 * Activation:
 *   - DEV (npm run dev / vite serve): always on, uses console.log
 *   - Production builds (Kundensystem incl. e2e prod): silent. vite.config.ts strips
 *     console.log via terser drop_console. To enable diagnostics in the customer
 *     environment without rebuilding, set window.__WIZARD_DEBUG__ = true in DevTools;
 *     this routes through console.warn (not stripped by terser) and survives the build.
 */
export const WIZARD_BATCH_QTY_TAG = 'WizardBatchQty';

declare global {
  interface Window {
    __WIZARD_DEBUG__?: boolean;
  }
}

export function isWizardBatchQtyDebugEnabled(): boolean {
  if (typeof window !== 'undefined' && window.__WIZARD_DEBUG__ === true) return true;
  return import.meta.env.DEV === true;
}

export function logWizardBatchQty(phase: string, payload: Record<string, unknown>): void {
  if (!isWizardBatchQtyDebugEnabled()) return;
  const label = `[${WIZARD_BATCH_QTY_TAG}] ${phase}`;
  // console.warn so the message survives terser's drop_console in production builds
  // (it removes console.log / .info / .debug, but not .warn / .error).
  console.warn(label, payload);
}
